<template>
  <el-dropdown @command="handleCommand" :teleported="false">
    <div class="avatar-wrapper">
      <img src="@/assets/images/menu/default-avatar.jpg" class="user-avatar" />
      <span class="user-nickname">杨氏xxx车企</span>
      <img src="@/assets/images/menu/bottom.png" class="bottom-icon" />
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <router-link to="/user/profile">
          <el-dropdown-item>修改名称</el-dropdown-item>
        </router-link>
        <router-link to="/user/profile">
          <el-dropdown-item>修改密码</el-dropdown-item>
        </router-link>
        <el-dropdown-item divided command="logout">
          <span>退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
<script setup>
const router = useRouter()
const handleCommand = (command) => {
  switch (command) {
    case 'logout':
      logout()
      break
    default:
      break
  }
}

const logout = () => {
  router.push('/login')
}
</script>
<style scoped lang="scss">
.avatar-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 17px 0 14px;
  cursor: pointer;
  // width: calc(200px - 31px);

  .user-avatar {
    width: 30px;
    height: 30px;
    margin-right: 14px;
    border-radius: 50%;
    &:focus-visible {
      outline: 2px solid rgb(166, 255, 0);
    }
  }

  .user-nickname {
    font-size: 16px;
    color: #0a1629;
  }

  .bottom-icon {
    margin-left: 21px;
    width: 10px;
    height: 6px;
  }

  i {
    cursor: pointer;
    position: absolute;
    right: -20px;
    top: 25px;
    font-size: 12px;
  }
}

:deep(.el-tooltip__trigger:focus-visible) {
  outline: unset;
}

:deep(.el-popper) {
  width: 100%;
  box-shadow: none;
  border-radius: 8px;
  border: none;
  .el-dropdown-menu {
    padding: 4px 6px;
    .el-dropdown-menu__item--divided {
      margin: 0;
    }

    .el-dropdown-menu__item {
      justify-content: center;
      font-size: 14px;
      font-weight: bold;
      color: #718096;
      padding: 15px 0;
    }
  }
}
</style>
